module.exports = __webpack_public_path__ + "static/img/11.0acd913.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/zh/11.png
// module id = rbjv
// module chunks = 0